import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  public loaderStateSignal = signal<boolean>(false);

  show() {
    this.loaderStateSignal.set(true);
  }

  hide() {
    this.loaderStateSignal.set(false);
  }
}
